webpackJsonp([58411574672382],{

/***/ 1822:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  width: 800px;\n  margin: 0 auto 200px;\n\n  @media screen and (max-width: 768px) {\n    width: 90%;\n    margin: 0 auto 50px;\n  }\n"], ["\n  width: 800px;\n  margin: 0 auto 200px;\n\n  @media screen and (max-width: 768px) {\n    width: 90%;\n    margin: 0 auto 50px;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  margin: 50px auto;\n  text-align: center;\n  h1,\n  h3 {\n    margin: auto;\n  }\n  h1 {\n    width: 80%;\n  }\n  h3 {\n    width: 85%;\n  }\n"], ["\n  margin: 50px auto;\n  text-align: center;\n  h1,\n  h3 {\n    margin: auto;\n  }\n  h1 {\n    width: 80%;\n  }\n  h3 {\n    width: 85%;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  display: grid;\n  grid-template-columns: 50% 50%;\n\n  @media screen and (max-width: 768px) {\n    display: flex;\n    flex-flow: column;\n  }\n\n  .Left {\n    display: flex;\n    flex-flow: column;\n    justify-content: space-between;\n  }\n\n  .Left > p {\n    margin: 20px 0;\n    padding-right: 50px;\n  }\n\n  .Right {\n    h4 {\n      margin-bottom: 10px;\n    }\n    padding-left: 50px;\n    .contact-item {\n      margin: 20px 0;\n    }\n\n    @media screen and (max-width: 768px) {\n      border: none;\n      padding: 0;\n    }\n  }\n\n  a {\n    margin-right: 20px;\n    font-size: 1.6rem;\n    background: rgba(67, 171, 96, 0.3);\n    border-bottom: 4px solid rgba(67, 171, 96, 0.8);\n    transition: all 0.3s ease;\n    padding: 3px 3px 0 3px;\n  }\n  a:hover {\n    background: rgba(67, 171, 96, 0.8);\n  }\n"], ["\n  display: grid;\n  grid-template-columns: 50% 50%;\n\n  @media screen and (max-width: 768px) {\n    display: flex;\n    flex-flow: column;\n  }\n\n  .Left {\n    display: flex;\n    flex-flow: column;\n    justify-content: space-between;\n  }\n\n  .Left > p {\n    margin: 20px 0;\n    padding-right: 50px;\n  }\n\n  .Right {\n    h4 {\n      margin-bottom: 10px;\n    }\n    padding-left: 50px;\n    .contact-item {\n      margin: 20px 0;\n    }\n\n    @media screen and (max-width: 768px) {\n      border: none;\n      padding: 0;\n    }\n  }\n\n  a {\n    margin-right: 20px;\n    font-size: 1.6rem;\n    background: rgba(67, 171, 96, 0.3);\n    border-bottom: 4px solid rgba(67, 171, 96, 0.8);\n    transition: all 0.3s ease;\n    padding: 3px 3px 0 3px;\n  }\n  a:hover {\n    background: rgba(67, 171, 96, 0.8);\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  border-bottom: 0.5px solid black;\n  width: 60%;\n  margin: 50px auto;\n"], ["\n  border-bottom: 0.5px solid black;\n  width: 60%;\n  margin: 50px auto;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactHelmet = __webpack_require__(16);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _SiteConfig = __webpack_require__(13);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactPage = function (_Component) {
	  _inherits(ContactPage, _Component);
	
	  function ContactPage() {
	    _classCallCheck(this, ContactPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ContactPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "contact" },
	      _react2.default.createElement(_reactHelmet2.default, { title: "Contact | " + _SiteConfig2.default.siteTitle }),
	      _react2.default.createElement(
	        ContactPageContainer,
	        null,
	        _react2.default.createElement(
	          PageHead,
	          null,
	          _react2.default.createElement(
	            "h1",
	            null,
	            "Contact Us"
	          ),
	          _react2.default.createElement(
	            "h3",
	            null,
	            "We're looking forward to working with you."
	          )
	        ),
	        _react2.default.createElement(PageDivider, null),
	        _react2.default.createElement(
	          ContactBody,
	          null,
	          _react2.default.createElement(
	            "div",
	            { className: "Left" },
	            _react2.default.createElement(
	              "p",
	              null,
	              "The best way to see if AppTree is the right fit for you is to see it in action."
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "We are on a mission to make enterprise software easier to build, deploy and support and we are looking for the best people to join us. Let us know if you are interested."
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "Right" },
	            _react2.default.createElement(
	              "div",
	              { className: "contact-item" },
	              _react2.default.createElement(
	                "h4",
	                null,
	                "AppTree Support"
	              ),
	              _react2.default.createElement(
	                "a",
	                { href: "mailto:support@apptreesoftware.com" },
	                "support@apptreesoftware.com"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "contact-item" },
	              _react2.default.createElement(
	                "h4",
	                null,
	                "Sales"
	              ),
	              _react2.default.createElement(
	                "a",
	                { href: "mailto:sales@apptreesoftware.com" },
	                "sales@apptreesoftware.com"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "888-680-8240"
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return ContactPage;
	}(_react.Component);
	
	var ContactPageContainer = _styledComponents2.default.div(_templateObject);
	
	var PageHead = _styledComponents2.default.div(_templateObject2);
	
	var ContactBody = _styledComponents2.default.div(_templateObject3);
	
	var PageDivider = _styledComponents2.default.div(_templateObject4);
	
	exports.default = ContactPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-jsx-cc62da857713a8239e2c.js